<template>
  <b-container class="text-left" fluid style="height: 83vh;overflow: hidden auto;">
    <b-row class="mt-2">
      <b-col cols="12">
         <b-row>
            <b-col cols="3">
              <b-card style="height: 260px;">
                <b-card-body>
                  <p>Company Registerd Records</p>
                  <!-- <h1>184M+</h1> -->
                  <b-card-text style="font-size:50px;" class="text-primary text-center">
                    <number
                      ref="number1"
                      :from="0"
                      :to="184"
                      :duration="4"
                      :delay="2"
                      easing="Power1.easeOut"
                    />M+
                  </b-card-text>
                  
                </b-card-body>
              </b-card>
            </b-col>
            <b-col cols="3">
              <b-card style="height: 260px;">
                <b-card-body>
                  <p>Instant Due Diligence Database</p>
                  <!-- <h1>XXX,XXX</h1> -->
                  <b-card-text style="font-size:50px;" class="text-primary text-center">
                    <number
                      ref="number1"
                      :from="0"
                      :to="9234513"
                      :duration="4"
                      :delay="2"
                      easing="Power1.easeOut"
                    />
                  </b-card-text>
                  <p>Sanctions & Enforcements</p>
                </b-card-body>
              </b-card>
            </b-col>
            <b-col cols="3">
              <b-card style="height: 260px;">
                <b-card-body>
                  <p>Instant Due Diligence PLUS</p>
                  <!-- <h1>10M+</h1> -->
                  <b-card-text style="font-size:50px;" class="text-primary text-center">
                    <number
                      ref="number1"
                      :from="0"
                      :to="10"
                      :duration="4"
                      :delay="2"
                      easing="Power1.easeOut"
                    />M+
                  </b-card-text>
                  <p>PEP & Other Risk Data</p>
                </b-card-body>
              </b-card>
            </b-col>
            <b-col cols="3">
              <b-card style="height: 260px;">
                <b-card-body>
                  <p>Ongoing Monitoring Alerts</p>
                  <!-- <h1>X,XXX,XXX?</h1> -->
                  <b-card-text style="font-size:50px;" class="text-primary text-center">
                    <number
                      ref="number1"
                      :from="0"
                      :to="7854902"
                      :duration="4"
                      :delay="2"
                      easing="Power1.easeOut"
                    />
                  </b-card-text>
                  <p>System wide</p>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
      </b-col>
    </b-row>
    <b-card class="my-3" no-body>
      <b-tabs small card fill justified lazy>
        <b-tab title="ANALYTICS">
          <AnalyticsTab />
        </b-tab>
        <b-tab title="QUESTIONNAIRES, POLICIES,  COMMUNICATIONS & TRAINING">
          <QuestionnairesStats />
        </b-tab>
      </b-tabs>
    </b-card>
  </b-container>
</template>
<script>
import AnalyticsTab from "../components/thirdPartyStatsComponent/analyticsTabChartComponent.vue";
// import QuestionnairesPoliciesTrainingTab from "../components/thirdPartyStatsComponent/questionnairesPoliciesTrainingTabChartComponent.vue";
import QuestionnairesStats from "./stats.vue";
export default {
  name: "ThirdpartyStatsPage",
  components: {
    AnalyticsTab,
    QuestionnairesStats
  },
  data() {
    return {
      Instant: 9234513
    };
  }
};
</script>